import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initKeycloak } from "./keycloak";

async function bootstrap() {

  await initKeycloak({
    onLoad: "check-sso",
    pkceMethod: "S256",
    // wenn du später willst: url/realm/clientId aus config ziehen
  });

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App  />
    </React.StrictMode>
  );
}

bootstrap();
